import { render, staticRenderFns } from "./UserReservationTable.vue?vue&type=template&id=53fad31f&scoped=true"
import script from "./UserReservationTable.vue?vue&type=script&lang=js"
export * from "./UserReservationTable.vue?vue&type=script&lang=js"
import style0 from "./UserReservationTable.vue?vue&type=style&index=0&id=53fad31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fad31f",
  null
  
)

export default component.exports